import React from "react";
import { Line } from "react-chartjs-2";
import { brandColorWithAlpha, getBrandPrimaryColor } from "../utils/brandingThemeColor";

const LinkLandingPageViews = ({ viewsGraphData }) => {
    const brandPrimaryColor = getBrandPrimaryColor();
    const barFillColor = brandColorWithAlpha(0.22);
    const barHoverFillColor = brandColorWithAlpha(0.35);

    const options = {
        type: 'line',
        plugins: {
            legend: {
              display: false,
              labels: {
                filter: function (item, chart) {
                    const dataset = chart.datasets[item.datasetIndex];
                    return dataset.displayInLegend;
                },
              },
            },
            tooltip: {
                filter: function (chart) {
                    const dataset = chart.dataset;
                    return dataset.displayInTooltip;
                },
            }
        },
        responsive: true,
        interaction: {
            mode: 'index',
            intersect: false
        },
        maintainAspectRatio: false,
        scales: {
            x: {
              grid: {
                  display: false,
                }
            },
            y: {
                grid: {
                  display: false,
                }
            }
        }
    };

  return (
    <>
      <div className="multiSalesChart">
        <Line
          width={100}
          height={500}
          data={{
            labels: viewsGraphData.labels,
            datasets: [
              {
                data: viewsGraphData.data,
                label: "Views",
                displayInLegend: false,
                displayInTooltip: true,
                fill: false,
                pointBorderWidth: 3,
                borderWidth: 2,
                tension: 0.5,
                pointBackgroundColor: brandPrimaryColor,
                pointBorderColor: brandPrimaryColor,
                pointHoverBorderColor: brandPrimaryColor,
                pointHoverBackgroundColor: brandPrimaryColor,
                borderColor: brandPrimaryColor,
                backgroundColor: brandColorWithAlpha(0.15)
              },
              {
                data: viewsGraphData.data,
                label: "Views",
                displayInLegend: true,
                displayInTooltip: false,
                pointBackgroundColor: brandPrimaryColor,
                borderColor: brandPrimaryColor,
                backgroundColor: barFillColor,
                hoverBackgroundColor: barHoverFillColor,
                borderWidth: 1,
                type: 'bar',
                fill: true
              }
            ]
          }}
          options={options}
        />
      </div>
    </>
  );
};

export default LinkLandingPageViews;
